import { defineComponent as a, openBlock as o, createBlock as d, unref as i } from "vue";
import m from "./ghl-ui.es353.js";
const r = a({
  name: "UISlider",
  inheritAttrs: !1
}), f = a({
  ...r,
  props: {
    value: {
      type: [Number, Array]
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    marks: {
      type: Object,
      default: void 0
    },
    tooltip: {
      type: Boolean,
      default: !0
    },
    defaultValue: {
      type: Number,
      default: void 0
    },
    formatTooltip: {
      type: Function,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: void 0
    }
  },
  emits: ["update:value"],
  setup(e) {
    return (l, t) => (o(), d(i(m), {
      "default-value": e.defaultValue,
      "format-tooltip": e.formatTooltip,
      tooltip: e.tooltip,
      marks: e.marks,
      step: e.step,
      max: e.max,
      min: e.min,
      value: e.value,
      "onUpdate:value": t[0] || (t[0] = (u) => l.$emit("update:value", u)),
      disabled: e.disabled
    }, null, 8, ["default-value", "format-tooltip", "tooltip", "marks", "step", "max", "min", "value", "disabled"]));
  }
}), s = f;
export {
  s as default
};
